// extracted by mini-css-extract-plugin
export default {"logoArea":"header_logoArea__7VJ+T","logo":"header_logo__BDgOO","helpGuide":"header_helpGuide__PDX1F","userArea":"header_userArea__ovzrY"};